module.exports = __webpack_public_path__ + "img/family-tree.f64088d3.jpg";